<template>
  <Photos year="2010" :min-date="1267574400" :max-date="1267747200" date-text="March 3&ndash;5" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
